import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { CONTROL_ENTITY_NAME, CONTROL_SECTION_NAME } from '../PromotionalButton/segment_constants';

type PromotionalControlTrackerProps = {
  isExperimentActive: boolean;
};

export function PromotionalControlTracker({ isExperimentActive }: PromotionalControlTrackerProps) {
  if (!isExperimentActive) {
    return null;
  }

  return (
    <ElementViewed entityName={CONTROL_ENTITY_NAME} sectionName={CONTROL_SECTION_NAME}>
      <div style={{ height: 0, overflow: 'hidden' }} />
    </ElementViewed>
  );
}
